import React, { useState, useEffect } from 'react';
import Slider from './Slider';
import AvatarEditor from 'react-avatar-editor'
import {
  MdRotate90DegreesCcw
} from 'react-icons/md';

import './styles.css';

function useEditImage(commands){

    const [imageScale, setImgScale] = useState(1);
    const [rotate, setRotationDegree] = useState(0);
    const [editor, setEditor] = useState();
    const [newImgURL, setNewImgURL] = useState();
    const handleResizeImage = (newSize) => {
      setImgScale(newSize[0]);
    }
    
    useEffect(()=>{
      commands.changeUserData('img',newImgURL);
      setImgScale(1);
      commands.finishEdit();
    },[newImgURL])

    const handleChangeImg = () => {
    setNewImgURL(editor?.getImageScaledToCanvas().toDataURL());
    };
    
    const handleSetEditorRef = (ed) => setEditor(ed);

    const handleRotate = () => setRotationDegree(rotate-90);

  return({
    localStates:{
      rotate,
      imageScale,
      editor
    },
    eventHandlers:{
      handleResizeImage,
      handleSetEditorRef,
      handleChangeImg,
      handleRotate
    },
  });
}


export default function EditImage(props) {
  
  const { commands, sharedStates } = props;
  const {localStates, eventHandlers} = useEditImage(commands);

  if (!(sharedStates.isEditing && sharedStates?.itemBeingEdited?.hasOwnProperty('file'))) return null;
  
  return (

    <div className="blur-background">
      <div
        className='modal-wrapper'
        style={{
          transform: (sharedStates.isEditing || true) ? 'translateY(0vh)' : 'translateY(-100vh)',
          opacity: (sharedStates.isEditing || true) ? '1' : '0',
        }}
      >
        <div className="modal-header">
          <span>Arraste e edite a imagem</span>
          <MdRotate90DegreesCcw  className='rotate-modal-btn' size={25} onClick={eventHandlers.handleRotate}/>
          <span className="close-modal-btn" onClick={commands.finishEdit}>×</span>
        </div>
        <div className="edit-box">
          <div className="edition-container">
            <AvatarEditor
              ref={eventHandlers.handleSetEditorRef}
              image={sharedStates.itemBeingEdited?.file}
              border={50}
              borderRadius={100}
              scale={localStates.imageScale}
              className='edit-avatar'
              color={[188,175,164,0.8]}
              rotate={localStates.rotate}
            
          />
          
           <Slider
           sharedStates = {localStates}
           commands = {eventHandlers}
           />
        </div>  
        <button onClick={eventHandlers.handleChangeImg}>Finalizar</button>
      </div>
    </div>
  </div>
  );
}

     



